module.exports = __webpack_public_path__ + "img/lx_bg.31f4bedf.png";